import { render, staticRenderFns } from "./UrunTurDigerBilgiler.vue?vue&type=template&id=ba861dee&scoped=true"
import script from "./UrunTurDigerBilgiler.vue?vue&type=script&lang=js"
export * from "./UrunTurDigerBilgiler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba861dee",
  null
  
)

export default component.exports